/** Find a WASM export function by name (case-insensitive). */
export function resolveDotnetExport(
  program: Record<string, unknown>,
  exports: Record<string, unknown>,
  names: string[]
): ((...args: unknown[]) => unknown) | undefined {
  for (const name of names) {
    const fromProgram = program[name];
    if (typeof fromProgram === "function") {
      return fromProgram as (...args: unknown[]) => unknown;
    }
    const fromExports = exports[name];
    if (typeof fromExports === "function") {
      return fromExports as (...args: unknown[]) => unknown;
    }
  }

  const wanted = new Set(names.map((n) => n.toLowerCase()));
  for (const [key, value] of Object.entries(program)) {
    if (wanted.has(key.toLowerCase()) && typeof value === "function") {
      return value as (...args: unknown[]) => unknown;
    }
  }
  for (const [key, value] of Object.entries(exports)) {
    if (wanted.has(key.toLowerCase()) && typeof value === "function") {
      return value as (...args: unknown[]) => unknown;
    }
  }
  return undefined;
}

export function listDotnetExportNames(
  program: Record<string, unknown>
): string[] {
  return Object.keys(program).filter(
    (k) => typeof program[k] === "function"
  );
}
